import { useEffect, useState } from 'react'
import type { HealthMetric } from '../types'
import { fetchHealth } from '../lib/api'
import { useBrandFilter, displayBrand } from '../lib/brand'

const LABELS: Record<string, string> = {
  paycom_last_24h_count:        'Pay.com events ingested (24h)',
  omega_last_24h_count:         'Omega rows ingested (24h)',
  matched_last_24h:             'Matched cleanly (24h)',
  mismatches_auto_resolved_24h: 'Auto-resolved mismatches (24h)',
  mismatches_pending:           'Pending (waiting for buffer)',
  mismatches_confirmed:         'Confirmed (needs review)',
  mismatches_acknowledged:      'Acknowledged (in progress)',
  replication_buffer_hours:     'Replication buffer (hours)',
}

export function Health() {
  const [brand] = useBrandFilter()
  const [rows, setRows] = useState<HealthMetric[] | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    ;(async () => {
      try {
        setRows(null)
        setRows(await fetchHealth())
      } catch (e) {
        setError((e as Error).message)
      }
    })()
  }, [brand])

  const byBrand: Record<string, HealthMetric[]> = {}
  ;(rows ?? []).forEach((r) => {
    byBrand[r.brand] ??= []
    byBrand[r.brand].push(r)
  })

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold">Health</h1>
      {error && (
        <div className="border border-red-500/40 bg-red-500/10 text-red-200 rounded px-3 py-2 text-sm">
          {error}
        </div>
      )}
      {rows &&
        Object.keys(byBrand)
          .sort()
          .map((b) => (
            <section key={b} className="space-y-3">
              <h2 className="text-lg font-medium text-slate-200">
                {displayBrand(b)}
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
                {byBrand[b].map((r) => (
                  <div
                    key={b + '-' + r.metric}
                    className="border border-slate-800 rounded-lg p-4"
                  >
                    <div className="text-xs uppercase tracking-wide text-slate-400">
                      {LABELS[r.metric] ?? r.metric}
                    </div>
                    <div className="text-2xl font-mono mt-1">{r.value}</div>
                  </div>
                ))}
              </div>
            </section>
          ))}
    </div>
  )
}
